/**
 * @generated SignedSource<<363f65d31534cffaed84ce1d38a0d140>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type reportCard_reportsOverviewPage$data = {
  readonly description: string;
  readonly name: string;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"reportImage_reportsOverviewPage">;
  readonly " $fragmentType": "reportCard_reportsOverviewPage";
};
export type reportCard_reportsOverviewPage$key = {
  readonly " $data"?: reportCard_reportsOverviewPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"reportCard_reportsOverviewPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "reportCard_reportsOverviewPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "reportImage_reportsOverviewPage"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "description"
      },
      "action": "THROW",
      "path": "description"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "url"
      },
      "action": "THROW",
      "path": "url"
    }
  ],
  "type": "JiraReport"
};

(node as any).hash = "12a47ad9a2cb96123c283a6213facd56";

export default node;
